import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { modeOfPaymentSchema } from "../../schemas/modeOfPaymentSchema";
import { addModeOfPayment } from "../../../../api/modeOfPaymentApi";
const AddModeOfPaymentDialog = ({
  openAddModeOfPayment,
  handleCloseAddModeOfPayment,
  currentModeOfPayment,
  fetchModeOfPayments,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(modeOfPaymentSchema),
    defaultValues: {
      name: "",
      serviceId: "",
      email: "",
      price: 0,
    },
  });

  useEffect(() => {
    let defaultValues = {};
    defaultValues.serviceId = currentModeOfPayment.serviceId;
    reset({ ...defaultValues });
  }, [currentModeOfPayment, reset]);

  const submitAddService = async (values) => {
    await addModeOfPayment(values);
    handleCloseAddModeOfPayment();
    fetchModeOfPayments();
  };

  return (
    <div>
      <StyledDialog
        open={openAddModeOfPayment}
        onClose={handleCloseAddModeOfPayment}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Add Mode Of Payment</DialogTitle>
        <form onSubmit={handleSubmit(submitAddService)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  variant="outlined"
                  label="Mode of Payment"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.name}
                  helperText={errors.name?.message}
                  {...register("name")}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseAddModeOfPayment}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default AddModeOfPaymentDialog;
